import React from 'react';
import moment from 'moment';
import AgentBadgeList from './AgentBadgeList';

/**
 * Renders a single chat message bubble.
 * User: right-aligned, blue background
 * Assistant: left-aligned, grey background with agent badges
 */
const ChatMessage = ({ message }) => {
  const isUser = message.role === 'user';
  const timeStr = moment(message.timestamp).format('h:mm a');

  // Simple markdown rendering: **bold**, *italic*, - bullet points
  const renderContent = (text) => {
    const lines = text.split('\n');
    return lines.map((line, i) => {
      // Handle bullet points
      if (line.trim().startsWith('- ') || line.trim().startsWith('• ')) {
        return (
          <li key={i} style={{ marginLeft: '1rem' }}>
            {formatInline(line.replace(/^[\s\-•]+/, ''))}
          </li>
        );
      }
      // Handle numbered lists
      if (/^\d+\.\s/.test(line.trim())) {
        return <li key={i} style={{ marginLeft: '1rem' }}>{formatInline(line.replace(/^\d+\.\s/, ''))}</li>;
      }
      // Empty line → paragraph break
      if (!line.trim()) {
        return <br key={i} />;
      }
      return <span key={i}>{formatInline(line)}<br /></span>;
    });
  };

  const formatInline = (text) => {
    // Bold: **text**
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((part, i) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={i}>{part.slice(2, -2)}</strong>;
      }
      return part;
    });
  };

  return (
    <div className={`chat-message-wrapper ${isUser ? 'user-message-wrapper' : 'assistant-message-wrapper'}`}>
      {/* Avatar */}
      <div className={`chat-avatar ${isUser ? 'user-avatar' : 'assistant-avatar'}`}>
        {isUser ? '👤' : '🤖'}
      </div>

      <div className="chat-bubble-container">
        <div className={`chat-bubble ${isUser ? 'user-bubble' : 'assistant-bubble'}`}>
          <div className="chat-content">{renderContent(message.content)}</div>
        </div>

        <div className="chat-meta">
          <span className="chat-timestamp">{timeStr}</span>
          {!isUser && message.agentsUsed?.length > 0 && (
            <AgentBadgeList agentsUsed={message.agentsUsed} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
